export default __webpack_public_path__ + "portfolio01.jpg";